module.exports = __webpack_public_path__ + "static/media/team-05.9bc17996.jpeg";